"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const image_1 = require("../../utils/image");
const CloudinaryImage = ({ data, fluid, ...rest }) => {
    if (!data) {
        // console.warn('Image not found')
        return null;
    }
    const props = { src: image_1.getCloudinaryImage(data), ...rest };
    if (fluid) {
        props.srcSet = [320, 480, 800]
            .map(width => {
            const src = image_1.getCloudinaryImage({ ...data, transform: `w_${width}` });
            return `${src} ${width}w`;
        })
            .join(', ');
    }
    return React.createElement("img", Object.assign({}, props));
};
exports.default = CloudinaryImage;
//# sourceMappingURL=index.js.map